import Big from 'big.js';
import { BigRoundMode } from '@/modules/common/constants/big-round-mode.ts';

export const withdrawAllAmount = (available: number | undefined, decimals: number) => {
  if (available === undefined || !Number.isFinite(available) || available <= 0) return undefined;
  const amount = Number(new Big(available).round(decimals, BigRoundMode.roundDown).toString());
  return amount > 0 ? amount : undefined;
};
